import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Link, Typography } from "@bca/ui-library";

import KeyDecisionMakerContainer from "./KeyDecisionMakerContainer";
import GradeUnknownSVG from "./Icons/ConditionReportIcons/GradeUnknownSVG";
import Grade1SVG from "./Icons/ConditionReportIcons/Grade1SVG";
import Grade2SVG from "./Icons/ConditionReportIcons/Grade2SVG";
import Grade3SVG from "./Icons/ConditionReportIcons/Grade3SVG";
import Grade4SVG from "./Icons/ConditionReportIcons/Grade4SVG";
import Grade5SVG from "./Icons/ConditionReportIcons/Grade5SVG";
import GradeRetailReadySVG from "./Icons/ConditionReportIcons/GradeRetailReadySVG";
import GradeUnclassifiedSVG from "./Icons/ConditionReportIcons/GradeUnclassifiedSVG";
import { KeyDecisionMakerText } from "./mechanicalReport/styledElements/KeyDecisionMakerText";

const gradeIcon = {
  0: {
    icon: <GradeUnknownSVG />,
    label: "Unknown",
  },
  1: {
    icon: <Grade1SVG />,
    label: "Grade 1",
  },
  2: {
    icon: <Grade2SVG />,
    label: "Grade 2",
  },
  3: {
    icon: <Grade3SVG />,
    label: "Grade 3",
  },
  4: {
    icon: <Grade4SVG />,
    label: "Grade 4",
  },
  5: {
    icon: <Grade5SVG />,
    label: "Grade 5",
  },
  6: {
    icon: <GradeRetailReadySVG />,
    label: "Retail Ready",
  },
  7: {
    icon: <GradeUnclassifiedSVG />,
    label: "Unclassified",
  },
};

const StyledLink = styled(Link)`
  ${css({
    fontSize: "body-small",
    textAlign: "center",
    paddingRight: [10, 0],
  })}
`;

const ConditionReport: React.FunctionComponent<{
  grade?: number;
  anchorLink?: string;
}> = ({ grade = 0, anchorLink = null }) => {
  return (
    <KeyDecisionMakerContainer>
      {(grade || grade === 0) && (
        <>
          <KeyDecisionMakerText>
            {gradeIcon[grade].icon}
            <Typography
              m={0}
              variant="h6"
              fontWeight="semiBold"
              color="footer-blue"
            >
              {gradeIcon[grade].label}
            </Typography>
          </KeyDecisionMakerText>
          {!!grade && anchorLink && anchorLink.length > 0 ? (
            <StyledLink
              href={anchorLink}
              target="_blank"
              color="primary-light-blue"
              underline="always"
              analytics={{
                eventLabel: "condition-report",
                eventAction: "download",
                eventSection: "primary-information",
              }}
            >
              Condition Report
            </StyledLink>
          ) : (
            <Typography variant="body-small" color="grey-blue" m={0}>
              Condition
            </Typography>
          )}
        </>
      )}
    </KeyDecisionMakerContainer>
  );
};

export default ConditionReport;
